<script>
import Vue from 'vue';

export default {
  name: 'BoardBinderMixin',
  methods: {
    onLoading() {
      this.collapseAllDetailRows();
      this.$store.commit('showLoading');
    },

    onLoadingSuccess() {
      this.$store.commit('hideLoading');
    },

    onFilterSet(filterText) {
      this.moreParams = {
        filter: filterText,
      };
      Vue.nextTick(() => (this.$refs.vuetable !== undefined ? this.$refs.vuetable.refresh() : {}));
    },

    onFilterReset() {
      this.moreParams = {};
      Vue.nextTick(() => (this.$refs.vuetable !== undefined ? this.$refs.vuetable.refresh() : {}));
    },

    onCheckboxToggle() {
      this.selectedCount = this.$refs.vuetable.selectedTo.length;
    },

    onCheckboxToggleAll() {
      this.selectedCount = this.$refs.vuetable.selectedTo.length;
    },

    onPaginationData(paginationData) {
      if (this.$refs.pagination === undefined) return;

      this.$refs.pagination.getPagination().setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    onRowClass(dataItem) {
      if (dataItem.is_checked === undefined || dataItem.is_checked === null) {
        return !dataItem.is_enabled ? 'row-submit' : 'row-none';
      }

      return !dataItem.is_checked ? 'row-submit' : 'row-none';
    },

    getSelectCount() {
      return this.selectedCount;
    },

    getSelected() {
      return this.$refs.vuetable.selectedTo;
    },

    resetSelectItems() {
      this.$refs.vuetable.selectedTo = [];
      this.selectedCount = 0;
    },

    async deleteRow(func) {
      if (this.getSelectCount() === 0) return;

      const rows = [];
      this.getSelected().forEach((index) => {
        rows.push(index);
      });

      await func(rows);

      this.updateField();
      this.resetSelectItems();
    },

    async insertRow(func) {
      const id = await func();

      this.updateField();
      this.collapseAllDetailRows();

      this.openInsertDetailRow(id);
    },
  },
  computed: {
    perPage() {
      return 10;
    },

    isLoading() {
      return this.$store.getters.isLoadingState;
    },
  },
  created() {
    const EventBus = new Vue();

    EventBus.updateField = () => {
      this.updateField();
      this.collapseAllDetailRows();
    };

    Object.defineProperties(Vue.prototype, {
      $table: {
        get: () => EventBus,
        configurable: true,
      },
    });
  },
  mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', () => this.onFilterReset());
  },
  data() {
    return {
      moreParams: {},
      selectedCount: 0,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/table/components/mixins/BoardBinderMixin.vue